import { cn } from "@omni/utils/styles";

import { Rating } from "@/components/Product/Rating/rating.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { formatNumber } from "@/utils/format";

type SummaryProps = {
    range: number;
    average: number;
    totalReviews: number;
    compact?: boolean;
};

export const Summary = ({
    range,
    average,
    totalReviews,
    compact = false
}: SummaryProps) => {
    const { t } = useGranite();

    const displayAverage = formatNumber(average, Config.getLocale(), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });

    return (
        <section className={cn("tw:flex tw:gap-4 tw:items-center")}>
            {!compact && (
                <div className={cn("tw:text-5xl")}>
                    <data value={average}>{displayAverage}</data>
                </div>
            )}
            <div>
                <div>
                    <Rating
                        value={average}
                        max={range}
                        size={16}
                    />
                </div>
                <p className={cn("tw:m-0")}>
                    {t("product.reviews.summary.reviews", totalReviews)}
                </p>
            </div>
        </section>
    );
};
